import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import { planning } from '../../../../api/integrations'
import ErrorBoundary from '../../../molecules/ErrorBoundary'
import GoalSummaryItem from './GoalSummaryItem'

const useStyles = (props) => makeStyles({
  goalSummary: {
    display: 'flex',
    gap: '1rem',
    flexFlow: 'wrap',
    '& .opal-card-md': {
      display: 'flex',
      flexDirection: 'column',
      gap: '.5rem',
      width: 'calc(50% - .5rem)'
    }
  }
})()

function GoalSummaryView ({
  clientId,
  planType,
  pageTitle,
  actionItems
}) {
  const styles = useStyles({ actionItems })

  const { data: goalsData, isLoading: goalsIsLoading } = planning.usePlanningQuery({ queryType: 'goalsummary', payload: { clientId, planType } })
  const { data: actionStepsData, isLoading: actionsStepsIsLoading } = planning.usePlanningQuery({ queryType: 'actionsteps', payload: { clientId, planType } })

  const { data, isLoading } = useMemo(() => {
    return {
      data: {
        planSummary: goalsData?.planSummary.map(p => {
          return {
            ...p,
            actions: actionStepsData?.data?.filter(d => d.goalId === p.goalId) ?? []
          }
        })
      },
      isLoading: goalsIsLoading || actionsStepsIsLoading
    }
  }, [goalsData, actionStepsData, goalsIsLoading, actionsStepsIsLoading])

  if (isLoading) return null

  return (
    <ErrorBoundary name={pageTitle}>
      <div className={styles.goalSummary}>
        {data.planSummary.map((goal) => (
          <GoalSummaryItem key={goal.goalId} goal={goal} />
        ))}
      </div>
    </ErrorBoundary>
  )
}

GoalSummaryView.propTypes = {
  clientId: PropTypes.number,
  planType: PropTypes.oneOf(['proposed', 'current']),
  pageTitle: PropTypes.string,
  actionItems: PropTypes.object
}

GoalSummaryView.defaultProps = {
  planType: 'current',
  pageTitle: 'Goal Summary',
  actionItems: {
    include: true,
    title: 'Action Items',
    itemColor: 'var(--color-decline-500)'
  }
}

export default GoalSummaryView
